import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

// 'visCacheVersion' doc name mirrored in functions/src/generateReport/firestorePaths.ts → VIS_CACHE_VERSION_PATH
const getVisCacheVersionRef = ({ accountId }: { accountId: string }) => {
  return firebase
    .firestore()
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.VISUALISATIONS_COLLECTION)
    .doc('visCacheVersion');
};

export default getVisCacheVersionRef;
